import { initFolders } from './folders';
import { initItems } from './items';
import { initItem } from './item';
import { initHttp } from '../../utils/http';
import { defaultSettings } from './settings';
import { addEvents } from '../decorators';
import { eventsList } from '../../events/list';
import { CorrelationId } from '../../utils/CorrelationId';
import { extendDeep } from '../../utils/utils';
export function Public(userSettings) {
  if (userSettings === void 0) {
    userSettings = {};
  }
  this.siteMediaToken = userSettings.siteMediaToken;
  const settings = extendDeep({}, defaultSettings, userSettings);
  const correlationId = new CorrelationId();
  const http = initHttp();
  const folders = initFolders(settings, http);
  const items = initItems(settings, http);
  const item = initItem(settings, http);
  this.name = 'public';
  this.correlationId = correlationId;
  this.folders = addEvents(this, eventsList.FOLDERS, folders);
  this.items = addEvents(this, eventsList.ITEMS, items);
  this.item = addEvents(this, eventsList.ITEM, item);
}